<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="班级">
                    <el-select v-model="form.classId" clearable filterable placeholder="班级">
                        <el-option
                            v-for="item in classOptin"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="form.state" clearable filterable placeholder="状态">
                        <el-option
                            v-for="item in stateOption"
                            :key="item.optionValue"
                            :label="item.optionText"
                            :value="item.optionValue">
                        </el-option>
                    </el-select>
                </el-form-item>

            </el-form>
            <div>
                <el-button type="primary"  @click="add({})">新增</el-button>
                <el-button type="primary" @click="exports()"><i class="el-icon-download"></i>导出</el-button>
            </div>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                 <el-table-column
                     min-width="120"
                     prop="sn"
                     label="卡劵号" >
                 </el-table-column>
                 <el-table-column
                    min-width="120"
                    prop="className"
                    label="班级" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="changeCount"
                    label="时长（天）" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="userName"
                    label="使用者" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="useTime"
                    label="使用时间" >
                </el-table-column>
               <el-table-column
                    min-width="120"
                    prop="createTime"
                    label="创建时间" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop=""
                    label="状态" >
                    <template slot-scope="scope">
                        <div class="fx-col fx-center" style="color: rgb(61 152 231);" v-if="scope.row.state == 1">
                              {{scope.row.stateName}}
                        </div>
                        <div class="fx-col fx-center" style="color:#69e93f" v-if="scope.row.state == 2">
                              {{scope.row.stateName}}
                        </div>
                        <div class="fx-col fx-center" style="color:#F56C6C" v-if="scope.row.state == 3">
                              {{scope.row.stateName}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="operatorName"
                    label="操作人" >
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="180"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <template>
                            <el-popconfirm @onConfirm="release(scope.row)" v-if="scope.row.state == 1"
                                           title="确认释放吗？"
                            >
                                <el-link type="danger" slot="reference"
                                         :underline="false" ><i class="iconfont icon-shanchu"></i><b>释放</b></el-link>
                            </el-popconfirm>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
        <Add v-if="showAdd" @submit="this.loadData"
                           @close="showAdd=false"></Add>
    </div>
</template>

<style scoped>
    .class_title {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        font-size: 16px;

    }
    .class_title i.iconfont {
        font-size: 20px;
        color: var(--primary);
    }
    .remove_btn {
        margin-left: 5px;
        cursor: pointer;
        font-size: 16px;
    }
    .remove_btn:hover {
        color: var(--danger);
    }
</style>


<script>
    import Add from '@/views/institution/cardCoupon/CardCouponAdd';
    export default {
        components: {
            Add,
        },

        data() {
            return {
                showAdd: false,
                form: {
                },
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                classOptin:[],
                stateOption:[],
                tableData: [],
                classFrom:{useType:2},
            }
        },
        watch: {
            "form": {
				handler: function (newValue) {
					this.pager.currentPage = 1;
					this.loadData();
				},
				deep: true
			}
        },

        methods: {
            loadData() {
                this.$ajaxPost("/cardCoupon/list", {
                    form:this.form,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                    this.showAdd = false;
                })
            },
            add(){
               this.showAdd = true;
            },
            release(item) {
                this.$ajaxGet("/cardCoupon/release/" + item.id, (data) => {
                    this.loadData();
                })
            },
            loadClassOptin() {
                this.$ajaxPost("/class/list",{form:this.classFrom}, (data) => {
                    this.classOptin = data.result;
                })
            },
            loadStateOption(){
                this.$ajaxGet("/cardCoupon/stateOptions", (data) => {
                    this.stateOption = data.result;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            exports() {
                window.open("/cardCoupon/exports?token="+localStorage.getItem("token"));
            }
        },

        created() {
            this.loadData();
            this.loadClassOptin();
            this.loadStateOption();
        }

    }
</script>
